export default __webpack_public_path__ + "static/media/p2-tip-box.daa50831.svg";